import { customAxiosInstanceMutator } from './custom-axios-instance';
import type { CustomerComment } from './schemas/customerServiceSchemas/customerComment';
import type { CustomerCommentPage } from './schemas/customerServiceSchemas/customerCommentPage';
import type { AddCustomerCommentContext as CommentContext } from './schemas/customerServiceSchemas/addCustomerCommentContext';

/**
 * Add a comment to a customer
 * @summary Add comment to customer
 */
export const addCustomerComment = (
  customerId: string,
  comment: string,
  context?: CommentContext,
  createdBy?: string,
  signal?: AbortSignal
) => {
  return customAxiosInstanceMutator<CustomerComment>(
    {
      url: `/customer/api/v1/customers/${customerId}/comments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: { comment, ...(context ? { context } : {}), ...(createdBy ? { createdBy } : {}) },
      signal
    },
  );
};

/**
 * Retrieve comments for a customer (paginated, newest first)
 * @summary Get customer comments
 */
export const getCustomerComments = (
  customerId: string,
  params?: {
    context?: CommentContext;
    page?: number;
    size?: number;
  },
  signal?: AbortSignal
) => {
  return customAxiosInstanceMutator<CustomerCommentPage>(
    {
      url: `/customer/api/v1/customers/${customerId}/comments`,
      method: 'GET',
      params,
      signal
    },
  );
};

/**
 * Types for customer comment service
 */
export type AddCustomerCommentMutationResult = Awaited<ReturnType<typeof addCustomerComment>>;
export type AddCustomerCommentMutationError = Error;

export type GetCustomerCommentsQueryResult = Awaited<ReturnType<typeof getCustomerComments>>;
export type GetCustomerCommentsQueryError = Error;